import PropTypes from 'prop-types';
import { Button, CardActions, CardHeader, Grid } from '@material-ui/core';

const LANDING_SUBHEADER =
  'Click the button below to continue and set your password.';
const CONTINUE_LABEL = 'Continue';

const subheaderTypographyProps = { color: 'textSecondary', variant: 'body2' };

const ValidationLanding = ({ busy, onContinue }) => (
  <>
    <CardHeader
      subheader={LANDING_SUBHEADER}
      subheaderTypographyProps={subheaderTypographyProps}
    />
    <CardActions>
      <Grid container justifyContent="center">
        <Grid item>
          <Button
            color="primary"
            disabled={busy}
            onClick={onContinue}
            size="large"
            variant="contained"
          >
            {CONTINUE_LABEL}
          </Button>
        </Grid>
      </Grid>
    </CardActions>
  </>
);

ValidationLanding.propTypes = {
  busy: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
};

ValidationLanding.defaultProps = {
  busy: false,
};

export default ValidationLanding;
export { LANDING_SUBHEADER, CONTINUE_LABEL };
